import { useMutation, useQueryClient } from "react-query";
import { EExercisesQueryKeys } from "api/endpoints/exercises";
import { removeExercise } from "api/services/exercises";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

export const useRemoveExercise = (
  courseId: TUrlParam,
  lessonId: TUrlParam,
  chapterId: TUrlParam
) => {
  const queryClient = useQueryClient();
  return useMutation<void, TApiError, number>(
    (exerciseId: number) =>
      removeExercise(courseId, lessonId, chapterId, exerciseId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(EExercisesQueryKeys.getExercises);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
